import { WithId, WithPagination } from '.'

export enum ContactStatus {
  CORRECT = 1,
  WARNING,
  ERROR,
}

export interface Contractor extends WithId {
  name: string
  taxNumber: string
  contactStatus: ContactStatus
}

export interface ContractorContact {
  id: number
  name: string
  emailAddress: string | null
  phoneNumber: string | null
  countryId: number
  isEmailAddressActive: boolean
  isPhoneNumberActive: boolean
  isDefault?: boolean
}

export interface AddContractorRequest {
  name: string
  taxNumber: string
  nationalBusinessRegistryNumber?: string | null
  street: string
  apartmentNumber: string | null
  buildingNumber: string
  city: string
  zipCode: string
  countryId: number
  contact: {
    countryId?: number
    emailAddress?: string | null
    phoneNumber?: string | null
    isContactActive?: boolean
  } | null
}

export interface AddContractorResponse {
  id: number
  name: string
  taxNumber: string
  nationalBusinessRegistryNumber: string
  street: string
  apartmentNumber: string
  buildingNumber: string
  city: string
  zipCode: string
  countryName: string
  contactStatus: number
}

export type FetchContractorByTaxIdResponse = AddContractorResponse

export interface ContractorContactPutRequest extends ContractorContact {
  contractorId: number
}

export type ContractorContactPostRequest = Omit<
  ContractorContactPutRequest,
  'id'
>

export type ContractorContactDeleteRequest = Pick<
  ContractorContactPutRequest,
  'id' | 'contractorId'
>

export interface ContractorDetails extends WithId {
  taxNumber: string
  name: string
  nationalBusinessRegistryNumber?: string
  street: string
  buildingNumber: string
  apartmentNumber: string | null
  city: string
  zipCode: string
  countryName: string
  countryId: number
  contactStatus: number
}

export interface ContractorsDataResponse extends WithPagination {
  results: Contractor[]
  totalRowsCount: number
}

export interface ContractorTab {
  title: string
  status?: ContactStatus
}

export interface ContractorFilters {
  search?: string
  onlyIncomplete: boolean
  page: number
  pageSize?: number
}

export type ContractorAutocomplete = Omit<Contractor, 'contactStatus'>

export interface GetContractorsAutocompleteRequest extends WithPagination {
  searching: string
}

export interface GetContractorsAutocompleteResponse extends WithPagination {
  results: Contractor[]
  totalRowsCount: number
}

export type ContractorsAutocomplete = ContractorAutocomplete[]

export type ContactFormValues = Omit<
  ContractorContact,
  'isEmailAddressActive' | 'isPhoneNumberActive' | 'id'
>

export type ContractorFormValues = Omit<
  ContractorDetails,
  'contactStatus' | 'id' | 'countryName' | 'countryId'
> &
  Pick<Contractor, 'name'> &
  Partial<
    Pick<ContractorContact, 'emailAddress' | 'phoneNumber' | 'countryId'>
  > & {
    phonePrefix?: number
    isContactActive?: boolean
  }
